import { toaster } from "@/components/ui/toaster";

interface OpenOnboardingFileProps {
  disabled: boolean;
  showMustStartReviewToast: () => void;
  url?: string;
  filename?: string;
}
export const openOnboardingFile = async ({
  disabled,
  showMustStartReviewToast,
  url,
  filename,
}: OpenOnboardingFileProps) => {
    if (disabled) {
      showMustStartReviewToast();
      return;
    }

    if (!url?.trim()?.length) {
      toaster.create({
        type: "error",
        title: "No hay un archivo disponible para descargar.",
      });
      return;
    }

    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    if (filename?.trim()?.length) {
      a.download = filename;
    }
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const normalizeTemplateDocName = (value: string) =>
  value
    .normalize("NFD")
    .replaceAll(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replaceAll(/\s+/g, " ")
    .trim();

export const extractTemplateDocNames = (text: string) => {
  const firstLineNameRegex = /^[-*]\s*(.+)$/;
  const blocks = text
    .split(/\n\n+/)
    .map((b) => b.trim())
    .filter(Boolean);
  const names = new Set<string>();
  for (const b of blocks) {
    const firstLine = (b.split("\n")[0] ?? "").trim();
    const match = firstLineNameRegex.exec(firstLine);
    const name = match?.[1]?.trim();
    if (name) names.add(normalizeTemplateDocName(name));
  }
  return names;
};

export const mergeRequireChangesText = (current: string, template: string) => {
  const cur = (current ?? "").trim();
  const tpl = (template ?? "").trim();
  if (!tpl.length) return cur;
  if (!cur.length) return tpl;

  const currentNames = extractTemplateDocNames(cur);
  const templateBlocks = tpl
    .split(/\n\n+/)
    .map((b) => b.trim())
    .filter(Boolean);

  const missingBlocks: string[] = [];
  for (const b of templateBlocks) {
    const firstLine = (b.split("\n")[0] ?? "").trim();
    const match = /^[-*]\s*(.+)$/.exec(firstLine);
    const name = match?.[1]?.trim();
    if (!name) continue;
    const norm = normalizeTemplateDocName(name);
    if (!currentNames.has(norm)) missingBlocks.push(b);
  }

  if (!missingBlocks.length) return cur;
  return `${cur}\n\n${missingBlocks.join("\n\n")}`;
};
